import logo from "../../images/logo.svg";
import { useState } from "react";
import SideBarItem from "./SideBarItem";
import SideBarItemII from "./SideBarItemII";
import dashIcon from "../../images/dash icon.svg"
import riderIcon from "../../images/dispatch riders icon.svg"
import orderIcon from "../../images/order icon.svg"
import earnIcon from "../../images/earning icon.svg"
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/features/authSlice";
import { useNavigate } from "react-router-dom";


export default function SideBar() {

    const retrievedData = localStorage.getItem("sidebarStates")
    const sb = JSON.parse(retrievedData)

    const [dispatchDrpdwn, setDispatchDrpdwn] = useState(sb ? sb.disp : false);
    const [orderDrpdwn, setOrderDrpdwn] = useState(sb ? sb.order : false);
    const [statementDrpdwn, setStatementDrpdwn] = useState(sb ? sb.statement : false);
    const [earnDrpdwn, setEarnDrpdwn] = useState(sb ? sb.earn : false);
    const userType = useSelector((state) => state.auth?.user?.userType)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const sbState = { disp: dispatchDrpdwn, order: orderDrpdwn, statement: statementDrpdwn, earn: earnDrpdwn }
    localStorage.setItem("sidebarStates", JSON.stringify(sbState))
 
    const logUserOut = () => {
        dispatch(logout())
        navigate("/")
    }
    
    const handleDrpdwn = (state, setState) => {
        setState(!state)
    }

    return (
        <aside>
            <div className="dash-logo mb-5">
                <img src={logo} alt="logo" />
                <span className="logo-txt ms-2">Flash</span>
            </div>
            <nav className="mb-5">
                <SideBarItem 
                    name="Dashboard"
                    link="/dashboard/"
                    icon={dashIcon}
                    img={true}
                />
                <SideBarItem 
                    name="Users"
                    link="/dashboard/users"
                    icon="group"
                />
                
                {userType === "superAdmin" && 
                    <SideBarItem 
                        name="Admins"
                        link="/dashboard/admins"
                        icon="admin"
                    />
                }
                <SideBarItemII 
                    name="Dispatch Riders"
                    icon={riderIcon}
                    img={true}
                    active={dispatchDrpdwn}
                    handler={() => handleDrpdwn(dispatchDrpdwn, setDispatchDrpdwn)}
                />
                { dispatchDrpdwn ? (
                    <nav className="sidebar-dropdown">
                        <SideBarItem 
                            name="Riders"
                            link="/dashboard/riders"
                            icon="arrow-right-s"
                        />
                        <SideBarItem 
                            name="Unapproved Riders"
                            link="/dashboard/unapproved-riders"
                            icon="arrow-right-s"
                        />
                    </nav>
                ) : '' }

                <SideBarItemII 
                    name="Order"
                    icon={orderIcon}
                    img={true}
                    active={orderDrpdwn}
                    handler={() => handleDrpdwn(orderDrpdwn, setOrderDrpdwn)}
                />
                { orderDrpdwn ? (
                    <nav className="sidebar-dropdown">
                        <SideBarItem 
                            name="All Orders"
                            link="/dashboard/all-orders"
                            icon="arrow-right-s"
                        />
                        <SideBarItem 
                            name="Pending Orders"
                            link="/dashboard/pending-orders"
                            icon="arrow-right-s"
                        />
                        <SideBarItem 
                            name="Completed Orders"
                            link="/dashboard/completed-orders"
                            icon="arrow-right-s"
                        />
                        <SideBarItem 
                            name="Cancelled Orders"
                            link="/dashboard/cancelled-orders"
                            icon="arrow-right-s"
                        />
                    </nav>
                ) : '' }
                
                <SideBarItemII 
                    name="Earnings"
                    icon={earnIcon}
                    img={true}
                    active={earnDrpdwn}
                    handler={() => handleDrpdwn(earnDrpdwn, setEarnDrpdwn)}
                />
                { earnDrpdwn ? (
                    <nav className="sidebar-dropdown">
                        <SideBarItem 
                            name="Admin Earnings"
                            link="/dashboard/admin-earnings"
                            icon="arrow-right-s"
                        />
                        <SideBarItem 
                            name="Riders Earnings"
                            link="/dashboard/riders-earnings"
                            icon="arrow-right-s"
                        />
                    </nav>
                ) : '' }

                {/* <SideBarItem 
                    name="Track"
                    link="/dashboard/track"
                    icon="map-pin"
                /> */}
                
                <SideBarItemII 
                    name="Statement"
                    icon="file-4"
                    active={statementDrpdwn}
                    handler={() => handleDrpdwn(statementDrpdwn, setStatementDrpdwn)}
                />
                { statementDrpdwn ? (
                    <nav className="sidebar-dropdown">
                        <SideBarItem 
                            name="Overall Statements"
                            link="/dashboard/overall-statement"
                            icon="arrow-right-s"
                        />
                        <SideBarItem 
                            name="Daily Statements"
                            link="/dashboard/daily-statement"
                            icon="arrow-right-s"
                        />
                        <SideBarItem 
                            name="Monthly Statements"
                            link="/dashboard/monthly-statement"
                            icon="arrow-right-s"
                        />
                    </nav>
                ) : '' }
                
                <SideBarItem 
                    name="Settings"
                    link="/dashboard/settings"
                    icon="settings-4"
                />



            </nav>
            <div onClick={logUserOut} className="text-dark mt-3 logout-btn c-pointer text-decoration-none d-block p-2">
                <i className="ri-logout-box-r-line ri-lg pe-3"></i>
                Logout
            </div>
        </aside>
    )
}